import { reloadicons } from './svg.js';
import { pageLoadingOff, pageLoadingOn, showOverlay } from './utilities.js';
import './rating/star-rating.js';
import './jquery.bxslider';
import 'slick-carousel';
import PinchZoom from 'pinch-zoom-js';
import '../../themes/product.css'
import '../../themes/product-description.css'


jQuery( async function ()  {

	await import('./rating/theme.js');

	const { addCart } = await import('./carrinho.js');
	/*
	* Tooltip
	*/
	if ($("a.tooltip-satisfacao").length > 0) {
		$("a.tooltip-satisfacao[title]").tooltip({ tip: '#tooltip-satisfacao' });
	}

	/* Calcular frete pelo carrinho */
	$('form#form-product-carrier .btn-calcular').click(function () {
		setProductCarrier();
	});

	$('form#form-product-carrier').on('submit', (e) =>{
		e.preventDefault();
		e.stopImmediatePropagation()
		setProductCarrier();
	})

	// Avaliações presentes no carrossel na página do produto
	$(".produto-avaliacoes-caroussel .rating-box input").rating({
		hoverOnClear: false,
		theme: 'krajee-svg',
		disabled: true,
		showCaption: false,
		showCaptionAsTitle: false,
		clearButtonBaseClass: 'displaynone',
		hoverEnabled: false,
		size: 'xs',
	});

	// Avaliação do produto nas informações (Junto com nome, preço e etc)
	$(".produto-container .rating .stars input").rating({
		hoverOnClear: false,
		theme: 'krajee-svg',
		displayOnly: true,
		showCaption: false,
		showCaptionAsTitle: false,
		clearButtonBaseClass: 'displaynone',
		hoverEnabled: false,
		size: 'xs',
	});

	$(".product-info .rating, .product-info .rating .star").on('click', function () {
		window.location.href = '#avaliacoes';
	});

	// Campo para avaliar o produto
	$(".produto-container #avaliacoes #rating form input[name=note]").rating({
		theme: 'krajee-svg',
		step: 1,
		showCaption: false,
		showCaptionAsTitle: false,
		clearButtonBaseClass: 'displaynone',
		size: 'sm',
	});

	// Avaliações página produto - parte "Deixe sua avaliação"
	$(".produto-container #avaliacoes #rating .rating-total input").rating({
		hoverOnClear: false,
		theme: 'krajee-svg',
		disabled: true,
		showCaption: false,
		showCaptionAsTitle: false,
		clearButtonBaseClass: 'displaynone',
		hoverEnabled: false,
		size: 'sm',
	});

	//Pinch-Zom (deve ser feito antes do carrousel ser inicializado) - https://github.com/manuelstofer/pinchzoom
	if (window.innerWidth <= 991) {
		document.querySelectorAll(".produto-images-caroussel-mobile div[data-photo]")
			?.forEach(container => {
				const p = new PinchZoom(container, { 
					draggableUnzoomed: false,
					tapZoomFactor: false,
					maxZoom: 10
				});
		});
	}
	
	$('.produto-images-caroussel-mobile').slick({
		dots: true,
		arrows: false,
		autoplay: false,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		touchThreshold: 1000
	});

	$('.produto-similares-caroussel').slick({
		dots: true,
		arrows: false,
		infinite: false,
		autoplay: false,
		speed: 300,
		slidesToShow: 4,
		touchThreshold: 1000,
		slidesToScroll: 1,
		lazyLoad: 'ondemand',
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 4,
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 2,
				}
			}
		]
	});

	$('.produto-avaliacoes-caroussel').slick({
		dots: true,
		arrows: false,
		infinite: false,
		autoplay: true,
		speed: 300,
		slidesToShow: 4,
		touchThreshold: 1000,
		slidesToScroll: 1,
		lazyLoad: 'ondemand',
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 4,
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 2,
				}
			}
		]
	});

	/*
	$(document).on("click mouseover", ".produto-images-caroussel [data-photo]",function(e){
		e.preventDefault();
		var photo = $(this).attr("data-photo");
		alterarphoto(photo);
	});
	*/

	$('.sku-single label').on('click', function (e) {
		const photoColor = $(this).find("input[name='photos']");
		if (photoColor.val() != undefined) {
			changeThumbByColor(photoColor, thumbSlider);
			changeThumbByColorMobile(photoColor);
		}

		if ($(this).hasClass("active")) { return; }
		$(this).parent().find('label').removeClass('active');
		$(this).addClass('active');

		// Altera o preço, código, parcela e descontos 
		$('.product-info .price span').html('R$ '+ $(this).attr('data-option-price'));
		$('.product-info #product-payments-discount .price-discount').html('R$ '+ $(this).attr('data-option-for-only'));
		$('#product-id').html($(this).attr('data-option-code'));
		
		if ($(this).attr('data-option-price-of') != "") {
			var skuPrice = $('.product-info .price');
			var skuPriceOf = $('.product-info .price-of').html('<span>' + $(this).attr('data-option-price-of') + '</span>');
			
			$('.product-info #form-product-buy .prices').html(skuPriceOf);
			$('.product-info #form-product-buy .prices').append(skuPrice);
		} else {
			if ($('#form-product-buy .prices .price-of') != null) {
				$('#form-product-buy .prices .price-of').remove();
			}
		}

		var optionId = $(this).find('input').val();
		var productId = $('#form-product-buy input[name=product_id]').val();
		var productUrl = $('#form-product-buy input[name=product_url]').val();
		var optionPrice = $(this).attr('data-option-price');
		
		pageLoadingOn()
		$.ajax({
			type: "GET",
			url: productUrl,
			data: "productId=" + productId + "&skuId=" + optionId,
			dataType: "json",
			async: false,
			success: function (json) {
				var discountsParcels = $('.discounts-parcels');
				if(discountsParcels == "")
					discountsParcels.html(json.discount);
				reloadicons(); // icone dropdown das parcelas
				$('.discounts-parcels').find('.price-prazo').html(optionPrice);
				$('.discounts-parcels').html(json.discount);
				$('#product-payments-discount').html(json.paymentsDiscount);
				$('.product-quantity input#amount').val(1);
				$('.product-quantity input#amount').attr('data-supply', json.supply);
				
				if (json.unavailable != null) {
					$('#form-product-buy .add-cart-div').addClass("displaynone");
					$('#form-product-buy .btn-comprar').addClass("displaynone");
					$('#form-product-carrier').addClass("displaynone");
					$(json.unavailable).insertAfter('#form-product-buy .sku-info');
					$('html, body').animate({
						scrollTop: $('#form-product-buy').offset().top + 50
					}, 300);
				} else {
					$('#form-product-buy .add-cart-div').removeClass("displaynone");
					$('#form-product-buy .btn-comprar').removeClass("displaynone");
					$('#form-product-carrier').removeClass("displaynone");
					if ($('#form-product-buy #unavailable-form').length > 0) {
						$('#form-product-buy #unavailable-form').remove();
					}
				}
				pageLoadingOff()
			}
		});

		// Se tiver alerta, remove
		$('#form-product-buy .alert').addClass('displaynone');
		$("form#form-product-carrier .alert").addClass('displaynone');
	});

	$(".product").on("click", ".product-info .add-cart", function (e) {
		e.preventDefault();
		var amount = 1;
		var amountEle = $(".product-info .product-quantity input[name=amount]");

		if (amountEle.length > 0) {
			amountEle.each(function (e) {
				if ($(this).is(":visible")) {
					amount = $(this).val();
				}
			});
		}

		var prodId = $(".product-info .form-product-buy [name=product_id]").val();

		var skuId = getSkuId();
		var sku_1 = "";
		var sku_2 = "";
		if (skuId.length == 1) {
			sku_1 = skuId[0];
		} else if (skuId.length == 2) {
			sku_1 = skuId[0];
			sku_2 = skuId[1];
		}
		var retorno = validaSku();
		if (retorno == 1) {
			addCart(prodId, sku_1, sku_2, amount);
		};
	});

	$(".product").on("click", "#bundles .btn-comprar", function(e) {
		e.preventDefault();
		const produtos = $(this).parent().parent().find(".item");
		let prodId = '';
		if (produtos.length > 0) {
			produtos.each(function (e) {
				prodId = $(this).find('.product-thumb').attr('data-product');
				if (prodId !== undefined || prodId != '') {
					addCart(prodId, "", "", 1);
				}
			});
		}
	});

	$(".product .product-quantity span, .product-thumb-info .product-quantity span, .product .product-quantity input[type=button]").on("click", function (e) {
		var alertsupply = $(this).parent().parent().parent().parent().parent().find('.alert.alertsupply');
		alertsupply.addClass('displaynone');
		var element = $(this).parent().find("input[name=amount]");
		const period = parseInt(element.attr("data-period"))
		var unit = parseInt(element.attr("data-unit"));
		var supply = parseInt(element.attr("data-supply"));
		if (unit == undefined) {
			unit = 1;
		}
		if (supply == undefined) {
			supply = 1;
		}
		if ($(this).hasClass('qtyminus')) {
			var act = "rem";
		} else {
			var act = "add";
		}
		var amount = parseInt(element.val());
		if (act == 'rem' && amount > unit) {
			amount = amount - unit;
		} else if (act == 'add') {
			if (supply >= (amount+unit)) {
				amount = amount + unit;
			} else {
				if(period == 0) {
					if (supply >= (amount+unit)) {
						amount = amount + unit;
					} else {
						if (supply == 1) {
							alertsupply.find("span").html(supply+" item");
						} else {
							alertsupply.find("span").html(supply+" itens");
						}
						alertsupply.removeClass("displaynone");
					}
				}else {
					amount = amount + unit;
				}
			}
		}
		element.val(amount);
	});

	$('.produto-container #avaliacoes #rating button.deixar-avaliacao').on("click", function () {
		$('html, body').animate({ scrollTop: 0 }, 'slow');
		$('.desktop-header ul li.menuHeaderUserIcon a').mouseover()
	});

	var thumbSlider = $('#thumbs-vert').bxSlider({
		mode: 'vertical',
		minSlides: 4,
		maxSlides: 4,
		moveSlides: 1,
		slideMargin: 10,
		pager: false,
		controls: false,
		infiniteLoop: false
	});

	$(".produto-container .btn-voltar-thumb").on("click", function () {
		thumbSlider.goToPrevSlide();
	});
	$(".produto-container .btn-avancar-thumb").on("click", function () {
		thumbSlider.goToNextSlide();
	});

	/** 
	* Muda a foto principal
	*/
	$(".product").on("mousedown", ".images .thumbs .item", function (e) {
		var src = $(".main-photo").attr('data-mainurl');
		var key = $(this).attr('data-photo');
		$(".main-photo source").attr("srcset", src + "_" + key + "_650.webp");
		$(".main-photo").attr("data-zoom", src + "_" + key + "_2000.webp");
	});

	/** 
	* Zoom na foto principal
	*/
	let pz = null;
	$('.main-photo, .main-photo-mobile').on("mouseup touch", function (e) {
		var modalProductZoom = document.getElementById('overlay-product-zoom');
		var imgZoomUrl = $(this).attr('data-zoom');
		const imgElement = document.querySelector("#overlay-product-zoom .main-photo-zoom img");
		//$("#overlay-product-zoom .main-photo-zoom img").attr("src","");
		modalProductZoom.addEventListener('shown.bs.modal', function (event) {
			imgElement.src = imgZoomUrl;	
			imgElement.onload = () => {
				if (window.innerWidth <= 991 && pz === null) {
					var ele = document.querySelector('#overlay-product-zoom .pinchzoom');
					pz = new PinchZoom(ele, {
						maxZoom: 10
					});
				} else {
					//pz.disable(); //TODO, Resetar o zoom
				}
			}
		});
		showOverlay("overlay-product-zoom");
	});
	$('#overlay-product-zoom .thumbs-zoom').on("click", function (e) {
		var img = $(this).attr('data-src');
		$("#overlay-product-zoom .main-photo-zoom img").attr("src", img);
	});

		// Sku Duplo
	$('.sku-combination label').on('click', function (e) {
		const photoColor = $(this).find("input[name='photos']");
		changeThumbByColor(photoColor, thumbSlider);
		
		$(this).parent().find('label').removeClass('active');
		$(this).addClass('active');

		var skuoption = $(this).attr("data-option");

		if (skuoption == "option_1") {
			if ($(this).hasClass('photoOn')) {
				var photoId = $(this).find('.optionToolTip').attr('data-photo');
				//alterarphoto(photoId);
			}
			var optionId = $(this).find('input').val();
			$('.sku-combination .option_2').removeClass('disabled');
			$('.sku-combination .option_2 .btn-group').addClass("displaynone");
			$('.sku-combination .option_2 .btn-group.optionId' + optionId).removeClass("displaynone");
			$('.sku-combination .option_2 .btn-group.optionId' + optionId + ' label.active').trigger('click');
			$('.sku-combination .option_2 .btn-group.optionId' + optionId + ' label.active').trigger('touchstart');
			//$('.sku-combination .option_2 .btn-group.optionId'+optionId+' label.active input').prop('checked', true);
		}
		else if (skuoption == "option_2") {
			if ($(this).data('option-price-of') != "") {
				if ($('.product-info .price-of').length > 0) {
					$('.product-info .price-of span').html($(this).data('option-price-of'));
					$('.product-info .price span').html($(this).data('option-price'));
				}
				else {
					$('.product-info .price').remove();
					$('.product-info .prices').append('<span class="price-of"><span>'+$(this).data('option-price-of')+'<span></span>');
					$('.product-info .prices').append('<span id="price" class="price"><span>' + $(this).data('option-price') + '</span></span>')
				}
			} else {
					if ($('#form-product-buy .price-of') != null) {
						$('#form-product-buy .price-of').remove();
					}
					$('.product-info .price span').html($(this).data('option-price'));
			}

			var secondOptionId = $(this).find('input').val();
			$('.sku-combination .option_2 input').removeAttr('checked');
			$('.sku-combination .option_2 input').parent().removeClass('active');
			//$('.sku-combination .option_2 input[value='+secondOptionId+']').prop('checked', true);
			$('.sku-combination .option_2 input[value=' + secondOptionId + ']').parent().addClass('active');
			$('#price span span').html($(this).attr('data-option-price'));
			$('#product-id').html($(this).attr('data-option-code'));
			
			var productId = $('#form-product-buy input[name=product_id]').val();
			var productUrl = $('#form-product-buy input[name=product_url]').val();
			var optionId = $(this).attr('data-option-id');

			if ($('.sku-combination .option_1 label.active').length == 0) {
				return
			}

			$.ajax({
				type: "GET",
				url: productUrl,
				data: "productId=" + productId + "&skuId1=" + optionId + "&skuId2=" + secondOptionId,
				dataType: "json",
				async: false,
				success: function (json) {
					$('div.discounts-parcels').html(json.discount);
					$('div#parcelas-do-cartao').html(json.parcels);
					$('#product-payments-discount').html(json.paymentsDiscount);
					$('.product-quantity input#amount').val(1);
					$('.product-quantity input#amount').attr('data-supply', json.supply);
					
					if (json.unavailable != null) {
						if ($('#form-product-buy #unavailable-form').length == 0) {
							$('#form-product-buy .add-cart-div').addClass("displaynone");
							$('#form-product-buy .btn-comprar').addClass("displaynone");
							$('#form-product-carrier').addClass("displaynone");
							$(json.unavailable).insertAfter('#form-product-buy .sku-info');
							$('html, body').animate({
								scrollTop: $('#form-product-buy').offset().top + 50
							}, 300);
						}
					} else {
						$('#form-product-buy .add-cart-div').removeClass("displaynone");
						$('#form-product-buy .btn-comprar').removeClass("displaynone");
						$('#form-product-carrier').removeClass("displaynone");
						if ($('#form-product-buy #unavailable-form').length > 0) {
							$('#form-product-buy #unavailable-form').remove();
						}
					}
				}
			});
			pageLoadingOff();
		
			// Se tiver alerta, remove
			$('#form-product-buy .alert').addClass('displaynone');
			$("form#form-product-carrier .alert").addClass('displaynone');
		}
	});
	if ($('.sku-combination .option_1 label').length == 1) {
		$('.sku-combination .option_1 label').trigger("click");
	}

	// Somar 1 item na pagina do produto
	$("body.product .product-kit .quantity a.change-amount.sum").click(function () {
		var pos = $("body.product .product-kit .quantity a.change-amount.sum").index(this);
		var amount = parseFloat($($("input[name*=amount]").get(pos)).val());
		firstKit = $($("input[name*=amount]").get(pos)).data("firstkit");
		amount++;
		if (firstKit == 0 && amount >= 0) {
			$($("input[name*=amount]").get(pos)).val(amount);
		} else if (firstKit == 1 && amount > 0) {
			$($("input[name*=amount]").get(pos)).val(amount);
		}
	});

	// Subtrair 1 item na pagina do produto
	$("body.product .product-kit .quantity a.change-amount.sub").click(function () {
		var pos = $("body.product .product-kit .quantity a.change-amount.sub").index(this);
		var amount = parseFloat($($("input[name*=amount]").get(pos)).val());
		firstKit = $($("input[name*=amount]").get(pos)).data("firstkit");
		amount--;
		if (firstKit == 0 && amount >= 0) {
			$($("input[name*=amount]").get(pos)).val(amount);
		} else if (firstKit == 1 && amount > 0) {
			$($("input[name*=amount]").get(pos)).val(amount);
		}
	});

	// Atualizar a quantidade na caixa de texto na pagina do produto
	$("body.product .product-kit .quantity input[name*=amount]").change(function () {
		var pos = $("body.product .product-kit .quantity input[name*=amount]").index(this);
		var amount = parseFloat($($("input[name*=amount]").get(pos)).val());
		firstKit = $($("input[name*=amount]").get(pos)).data("firstkit");
		if (amount > 0) {
			$($("input[name*=amount]").get(pos)).val(amount);
		} else if (firstKit == 0 && amount >= 0) {
			$($("input[name*=amount]").get(pos)).val(amount);
		} else if (firstKit == 1 && amount <= 0) {
			$($("input[name*=amount]").get(pos)).val("1");
		} else {
			$($("input[name*=amount]").get(pos)).val("0");
		}
	});

	document.querySelector('.sku-single .btn')?.click();
	document.querySelector(".sku-combination .option_1 .btn")?.click();
	document.querySelector(".sku-combination .option_2 .btn")?.click();
});

export function setProductCarrier() {
	var zipcode = $("form#form-product-carrier input[name=zipcode]").val();
	if (zipcode != "") {
		var sku_obj = "";
		var sku_id = "";
		if ($("#form-product-buy .sku-combination").length > 0) {
			sku_obj = $("form#form-product-buy .sku-combination input:checked");
		} else if ($("#form-product-buy .sku-single").length > 0) {
			sku_obj = $("form#form-product-buy .sku-single input:checked");
		}
		if (sku_obj != "") {
			var nSkus = sku_obj.length;
			if (nSkus == 1) {
				var sku_id = sku_obj.val();
			} else if (nSkus > 1) {
				for (i = 0; i < nSkus; i++) {
					sku_id += $(sku_obj.get(i)).val();
					if (i < nSkus - 1) {
						sku_id += ",";
					}
				}
			}
		}
		const quantity = $("#form-product-buy input#amount").val() ?? 1;
		$("form#form-product-carrier fieldset.carriers").html("");
		var url = $("form#form-product-carrier").attr("data-product-url");
		$("form#form-product-carrier fieldset.carriers").html('<div class="loading"><div id="circularG"><div id="circularG_1" class="circularG"></div><div id="circularG_2" class="circularG"></div><div id="circularG_3" class="circularG"></div><div id="circularG_4" class="circularG"></div><div id="circularG_5" class="circularG"></div><div id="circularG_6" class="circularG"></div><div id="circularG_7" class="circularG"></div><div id="circularG_8" class="circularG"></div></div></div>');
		$.ajax({
			type: "GET",
			url: "./",
			data: "zipcode=" + zipcode + "&sku_id=" + sku_id + "&quantity=" + parseInt(quantity) + "&ajax",
			dataType: 'json',
			success: function (res) {
				if (res.error != undefined) {
					$("form#form-product-carrier").find('.main-alert').html('<a class="close" title="Fechar">×</a>');
					$("form#form-product-carrier").find('.main-alert').append('<p><span/>' + res.error + '</p>');
					$("form#form-product-carrier").find('.main-alert').fadeIn();

					$('#form-product-buy').find('.check-validator').each(function () {
						if ($(this).find('input:checked').length < 1) {
							$(this).find('.alert').fadeIn();
						}
					});
					$("form#form-product-carrier fieldset.carriers").html('');
					return false;
				} else if (res.html != undefined) {
					$("form#form-product-carrier").find('.main-alert').html('');
					$("form#form-product-carrier").find('.main-alert').addClass("displaynone");
					$("form#form-product-carrier fieldset.carriers").html(res.html);
				}
			}
		});
	} else {
		var msg = $("form#form-product-carrier").find('.main-alert').attr('data-alert');
		$("form#form-product-carrier").find('.main-alert').html('<a class="close" title="Fechar">×</a>');
		$("form#form-product-carrier").find('.main-alert').append('<p><span/>' + msg + '</p>');
		$("form#form-product-carrier").find('.main-alert').fadeIn();
		$("form#form-product-carrier").find('.main-alert').removeClass("displaynone");
	}
}

/*
function alterarphoto(photo) {
	var mainurl = $(".main-photo").attr("data-mainurl");
	var imgmain = $(".main-photo").attr("data-imgmain");
	var imgfull = $(".main-photo").attr("data-imgfull");
	var carousel = $(".produto-images-caroussel");
}
*/

function populateCarrouselImages() {
	try {
	const mobileDiv = document.querySelector('.produto-images-caroussel-mobile');
	const productUrl = mobileDiv.getAttribute('data-url');
	const images = mobileDiv.getAttribute('data-images');
	if (!images) return;
	let key = 0;
	for(const img of images) {
		key++;
		const node = $(mobileDiv).append(
			'<div class="d-flex justify-content-center align-items-center" data-photo="'+key+'"> <picture> <source srcset="/img/products/'+productUrl+'_'+key+'_900.webp" media="(max-width: 991px)"> <img srcset="/img/transparent.png" height="50vh"> </picture> </div>'
			);
	}
	$('.produto-images-caroussel-mobile').slick({
		dots: true,
		arrows: false,
		autoplay: false,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		touchThreshold: 1000
	});
	} catch (e) {
		console.error(e);
	}
}

export function getSkuId() {
	var retorno = [];
	if ($("#form-product-buy .sku-combination").length > 0) {
		$("#form-product-buy .sku-combination > fieldset").each(function (i, v) {
			if ($(this).is(":visible")) {
				if ($(this).find("select:visible").length > 0) {
					retorno.push($(this).find("select:visible").val());
				} else {
					retorno.push($(this).find("input:checked").val());
				}
			}
		});
	} else if ($("#form-product-buy .sku-single").length > 0) {
		$("#form-product-buy .sku-single").each(function (i, v) {
			if ($(this).is(":visible")) {
				if ($(this).find("select:visible").length > 0) {
					retorno.push($(this).find("select:visible").val());
				} else {
					retorno.push($(this).find("input:checked").val());
				}
			}
		});
	}
	return retorno;
}

export function getSkuIdold() {
	var sku_obj = "";
	var sku_id = "";
	var retorno = [];
	if ($("#form-product-buy .sku-combination").length > 0) {
		$("#form-product-buy .sku-combination > fieldset").each(function (i, v) {
			if ($(this).is(":visible")) {
				sku_obj = $(this).find("input:checked");
			}
		});
	} else if ($("#form-product-buy .sku-single").length > 0) {
		$("#form-product-buy .sku-single").each(function (i, v) {
			if ($(this).is(":visible")) {
				sku_obj = $(this).find('input:checked');
			}
		});
	}
	if (sku_obj != "") {
		var nSkus = sku_obj.length;
		if (nSkus == 1) {
			retorno.push(sku_obj.val());
		} else if (nSkus > 1) {
			for (i = 0; i < nSkus; i++) {
				retorno.push($(sku_obj.get(i)).val());
			}
		}
	}
	return retorno;
}

export function validaSku() {
	var retorno = 1;
	var check;
	if ($("#form-product-buy .sku-combination").length > 0) {
		$("#form-product-buy .sku-combination > fieldset").each(function (i, v) {
			if ($(this).is(":visible")) {
				check = $(this).find('input:checked').length;
				if (check == 1) {
					$(this).find(".invalid-feedback").css("display", "none");
				} else {
					$(this).find(".invalid-feedback").css("display", "block");
					retorno = 0;
				};
			}
		});
	} else if ($("#form-product-buy .sku-single").length > 0) {
		$("#form-product-buy .sku-single").each(function (i, v) {
			if ($(this).is(":visible")) {
				check = $(this).find('input:checked').length;
				if (check == 1) {
					$(this).find(".invalid-feedback").css("display", "none");
				} else {
					$(this).find(".invalid-feedback").css("display", "block");
					retorno = 0;
				};
			}
		});
	}
	return retorno;
}

/*
function mudarZoom(photo){  //Altera o zoom thumbs para o zm-viewer
	var mainurl = $(".main-photo").attr("data-mainurl");
	var imgfull = $(".main-photo").attr("data-imgfull");
	$(".zm-viewer img:nth-child(2)").attr("src", mainurl+"_"+photo+"_"+imgfull+".webp");
}
*/

export function changeThumbByColorMobile(option) {
	const mobilePhotos = option.val().split(',');
	const url = option.attr("data-url");
	const thumbSizeMobile = "300";
	if (true) {
		let carousel = $(".produto-images-caroussel-mobile");
		carousel.slick('unslick');
		carousel.html('');
		mobilePhotos.forEach(function (e) {
			carousel.append('<div class="bg-white d-flex justify-content-center align-items-center" data-photo=' + e + '><img class="img-responsive" src="' + url + '_' + e + '_' + thumbSizeMobile + '.webp" /></div>');
		});
		carousel = $('.produto-images-caroussel-mobile').slick({
			dots: true,
			arrows: false,
			autoplay: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			touchThreshold: 1000
		});
	}
}

/* Mudar a Thumb mudando a Cor*/
export function changeThumbByColor(color, thumbSlider) { //Feita para depois que a página caregga para se aproveitar do thumbSlider;
	if (color.val() != undefined) {
		const photosColorId = color.val().split(',');
		const url = color.attr("data-url");
		//muda a foto principal
		$(".main-photo img").attr("src", url + "_" + photosColorId[0] + "_650.webp");
		$(".main-photo").attr("data-zoom", url + "_" + photosColorId[0] + "_2000.webp");

		if ($('#thumbs-vert').length == 1) {
			thumbSlider.destroySlider(); // destroy the slider
		}
		
		//TODO O carrousel fica com problema ao recarregar.
		if (photosColorId.length >= 1) {
			const thumbImgs = document.querySelectorAll(".images .thumbs .item"); // Pega todas as imagens da thumb.
			if (photosColorId.length != 0) {
				thumbImgs.forEach((e) => {
					e.parentElement.removeChild(e); //Remove Todas as imagens da Thumb na página de Produtos.
				});
			}
			$('.images .thumbs').html("");
			for (let i = 0; i < photosColorId.length; i++) { // Adiciona Novas imagens dependendo da cor selectionada
				$('.images .thumbs').append('<div class="item d-flex justify-content-center align-items-center" data-photo=' + photosColorId[i] + '><img class="img-responsive" src="' + url + '_' + photosColorId[i] + '_72.webp"/></div>');
			}
		}
		if ($('#thumbs-vert').length == 1) {
			thumbSlider.reloadSlider(); // reload the slider
		}
	}
}
/* Fim Thumb Cor*/